// Angular Import
import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule, Event } from '@angular/router';
import { Title } from '@angular/platform-browser';

// project import
import { NavigationItem } from '../../types/navigation';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { menus } from 'src/app/demo/data/menu';
import { componentMenus } from 'src/app/demo/data/component';
import { TitleType } from '@mri/types';
import { GlobalPageService } from '../../../modules/global-page/global-page.service';
import { AuthResourceService } from '@mri/app/resources';


@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, SharedModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  // public props
  @Input() type: string;
  @Input() Component = false;
  @Input() dashboard = true;

  navigations: NavigationItem[];
  ComponentNavigations: NavigationItem[];
  navigationList: TitleType[];
  componentList: TitleType[];

  // constructor
  constructor(
    private route: Router,
    private titleService: Title,
    private _globalPageService: GlobalPageService,
    private _authSrv: AuthResourceService
  ) {
    this.navigations = menus;
    this.ComponentNavigations = componentMenus;
    this.type = 'theme1';
    this.setBreadcrumb();
  }

  ngOnInit(): void {
    this._globalPageService.breadcrumb$.subscribe((breadcrumb: Array<TitleType>) => {
      this.navigationList = breadcrumb;
    });
    this._globalPageService.title$.subscribe((title: string) => {
      this.titleService.setTitle(title + ' | ' + (this._authSrv.auth?.personalize?.nameOwn || ''));
    });
  }

  // public method
  setBreadcrumb() {
    this.route.events.subscribe((router: Event) => {
      if (router instanceof NavigationEnd) {
        const activeLink = router.url;
        const breadcrumbList = this.filterNavigation(this.navigations, activeLink);
        this.navigationList = breadcrumbList;
        this.componentList = this.filterNavigation(this.ComponentNavigations, activeLink);

        const last = breadcrumbList[breadcrumbList.length - 1];

        const title = last?.pageName || last?.title || 'Welcome';
        this.titleService.setTitle(title + ' | ' + (this._authSrv.auth?.personalize?.nameOwn || ''));
      }
    });
  }

  filterNavigation(navItems: NavigationItem[], activeLink: string): TitleType[] {
    for (const navItem of navItems) {
      if ('url' in navItem && navItem.url === activeLink) {
        return [
          {
            url: 'url' in navItem ? navItem.url : false,
            title: navItem.title,
            link: navItem.link,
            pageName: navItem.pageName,
            breadcrumbs: 'breadcrumbs' in navItem ? navItem.breadcrumbs : true,
            type: navItem.type
          }
        ];
      }
      if ('children' in navItem) {
        // eslint-disable-next-line
        const breadcrumbList = this.filterNavigation(navItem.children!, activeLink);
        if (breadcrumbList.length > 0) {
          breadcrumbList.unshift({
            url: 'url' in navItem ? navItem.url : false,
            title: navItem.title,
            pageName: navItem.pageName,
            link: navItem.link,
            breadcrumbs: 'breadcrumbs' in navItem ? navItem.breadcrumbs : true,
            type: navItem.type
          });
          return breadcrumbList;
        }
      }
    }
    return [];
  }


}
